<template>
  <div class="my-3">
    <label>{{ reservationItem.properties.title }}</label>
    <select @change="ItemValueController" v-model="itemValue" :required="itemRequiredStatus" class="custom-select">
      <option value=""> یکی از موارد را انتخاب کنید.</option>
      <option v-for="option in reservationItem.items" :value="option.id">{{ option.name }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: "ReservationExtraItem",
  props: {
    reservationItem: {}
  },
  data() {
    return {
      itemValue: ''
    }
  },
  computed: {
    itemRequiredStatus() {
      let status = this.reservationItem.properties.select_status == 'required' ? true : false;
      return status
    }
  },
  methods: {
    ItemValueController() {
      const id = this.reservationItem.id
      const value = this.itemValue
      const form = {
        id: id,
        value: value
      }
      this.$emit('itemValue', form)
    },
  }
}
</script>

<style scoped>

</style>